// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fix-pos[data-v-e5f93644] {\n    padding-top: 18px !important;\n}\n", ""]);
// Exports
module.exports = exports;
